export const isValidEmail = (email) => {
  if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
    return false
  }
  return true
}

const uppercaseRegExp = /(?=.*?[A-Z])/
const lowercaseRegExp = /(?=.*?[a-z])/
const digitsRegExp = /(?=.*?[0-9])/
const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/
const minLengthRegExp = /.{8,}/

export const validate = (values) => {
  const errors = {}
  let status = true
  if (!values.email) {
    errors.email = "email-required"
    status = false
  } else if (values.email) {
    if (!isValidEmail(values.email)) {
      errors.email = "invalid-email"
      status = false
    } else {
      errors.email = ""
      status = true
    }
  }
  if (!values.firstName) {
    errors.firstName = "validate-first-name"
    status = false
  } else if (values.firstName.length < 2) {
    errors.firstName = "validate-name-length"
    status = false
  }
  if (!values.lastName) {
    errors.lastName = "validate-last-name"
    status = false
  } else if (values.lastName.length < 2) {
    errors.lastName = "validate-name-length"
    status = false
  }
  if (!values?.password) {
    errors.password = "empty-password"
    status = false
  }
  if (values?.password) {
    const uppercasePassword = uppercaseRegExp.test(values.password)
    const lowercasePassword = lowercaseRegExp.test(values.password)
    const digitsPassword = digitsRegExp.test(values.password)
    const specialCharPassword = specialCharRegExp.test(values.password)
    const minLengthPassword = minLengthRegExp.test(values.password)
    if (!uppercasePassword) {
      errors.password = "validate-password-upper-letter"
      status = false
    } else if (!lowercasePassword) {
      errors.password = "validate-password-lower-letter"
      status = false
    } else if (!digitsPassword) {
      errors.password = "validate-password-number"
      status = false
    } else if (!minLengthPassword) {
      errors.password = "validate-password-length"
      status = false
    } else if (!specialCharPassword) {
      errors.password = "validate-password-symbol"
      status = false
    } else {
      errors.password = ""
      status = true
    }
  }
  return { errors, status }
}
